module.exports = __webpack_public_path__ + "img/import_icon.c3ac65e4.svg";